/* import * as types from "./mutation-types"; */

export default {
  proposals_list(state, new_value){
    let temp = new_value
    temp.response.mansioni = temp.response.mansioni.filter(item => item.date)
    state.proposals_list = temp
  },
  current_proposal(state, new_value){
    state.current_proposal = new_value
  },
};
